import { CreditCardDataState, CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { combineReducers } from 'redux'
import { acceptRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/acceptRequestReducer'
import { ccActivationReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccActivationReducer'
import { ccCardsReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccCardsReducer'
import { ccLedgersReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccLedgersReducer'
import { ccOnboardingReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccOnboardingReducer'
import { ccPaymentMethodsReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccPaymentMethodsReducer'
import { ccPersonDataReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccPersonDataReducer'
import { replaceCardRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/replaceRequest'
import { ccRewardsReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccRewardsReducer'
import { ccTransactionsReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccTransactionsReducer'
import { ccUpcomingPaymentsReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccUpcomingPaymentsReducer'
import { createRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/phoneReducer'
import { createPaymentMethodRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/createPaymentMethodRequestReducer'
import { deletePaymentMethodRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/deletePaymentMethodRequestReducer'
import { createPaymentRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/createPaymentRequestReducer'
import { deletePaymentRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/deletePaymentRequestReducer'
import { createAutoPaymentRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/createAutoPaymentRequestReducer'
import { deleteAutoPaymentRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/deleteAutoPaymentRequestReducer'
import { ccShipmentAddressReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccShipmentAddressReducer'
import { initiateRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/initiateRequestReducer'
import { lockCardRequestReducer, unlockCardRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/lockCardReducer'
import { ccOnboardingStepsCountReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccOnboardingStepsCountReducer'
import { patchOnboardingPropsRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/patchOnboardingPropsReducer'
import { verifyPhoneReducer } from 'components/features/creditCard/creditCardStore/appReducers/verifyPhoneReducer'
import { ccPaymentsReducer } from 'components/features/creditCard/creditCardStore/dataReducers/ccPaymentsReducer'
import { waitlistRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/waitlistRequestReducer'
import { activateCardRequestReducer } from 'components/features/creditCard/creditCardStore/appReducers/activateCardReducer'

export const creditCardAppReducer = combineReducers<CreditCardAppState>({
  waitlistRequest: waitlistRequestReducer,
  initiateRequest: initiateRequestReducer,
  createPhoneRequest: createRequestReducer,
  verifyPhoneRequest: verifyPhoneReducer,
  patchOnboardingPropsRequest: patchOnboardingPropsRequestReducer,
  acceptRequest: acceptRequestReducer,
  activateCardRequest: activateCardRequestReducer,
  replaceCardRequest: replaceCardRequestReducer,
  lockCardRequest: lockCardRequestReducer,
  unlockCardRequest: unlockCardRequestReducer,
  createPaymentMethodRequest: createPaymentMethodRequestReducer,
  deletePaymentMethodRequest: deletePaymentMethodRequestReducer,
  createPaymentRequest: createPaymentRequestReducer,
  deletePaymentRequest: deletePaymentRequestReducer,
  createAutoPaymentRequest: createAutoPaymentRequestReducer,
  deleteAutoPaymentRequest: deleteAutoPaymentRequestReducer,
})

export const creditCardDataReducer = combineReducers<CreditCardDataState>({
  onboarding: ccOnboardingReducer,
  person_data: ccPersonDataReducer,
  cards: ccCardsReducer,
  ledgers: ccLedgersReducer,
  payments: ccPaymentsReducer,
  paymentMethods: ccPaymentMethodsReducer,
  transactions: ccTransactionsReducer,
  rewards: ccRewardsReducer,
  onboardingStepsCount: ccOnboardingStepsCountReducer,
  activation: ccActivationReducer,
  shipmentAddress: ccShipmentAddressReducer,
  upcomingPayments: ccUpcomingPaymentsReducer,
})
